<template>
<div style="height: 100%;">
  <b-container fluid>
    <b-row>
    <div class="graph-options-wrapper">
      <h2 class="label-graph-option">Sélectionner un type graphique</h2><br>
      <b-row>
          <b-col v-for="option in graphOptions" :key="option.keyg" lg="3" class="pb-2">
              <b-button 
                class="btn-options-graph"
                @click="displayGraph(option.keyg, option.name)"
                size="lg"
              >
                {{option.name}}
              </b-button>
          </b-col>
      </b-row>
    </div>
    </b-row>
    <b-row>
    <div class="graph-wrapper">
       <h4>Statistique</h4>
       <h3>{{selectedGraph}}</h3>
        <div style="margin-top: 2%;">
          <div v-if="isLoading">
            <i class="fa fa-spinner fa-spin fa-2x fa-fw" />
            Chargement...
          </div>
          <WorkstationStateGraph v-show="keyGraph == 'workstation_state'"></WorkstationStateGraph>
          <GraphControversyMaterial v-show="keyGraph == 'material_controversy'"></GraphControversyMaterial>
          <MaterialInExpeditonFlux v-show="keyGraph == 'material_in_exp_flux'"></MaterialInExpeditonFlux>
          <ExpeditionLeadTime v-show="keyGraph == 'exp_leadtime'"></ExpeditionLeadTime>
        </div>
    </div>
    </b-row>
  </b-container>
</div>
</template>

<script>
import server from '../../api/server.vue'
import WorkstationStateGraph from '../graph/WorkstationState.vue'
import GraphControversyMaterial from '../graph/GraphControversyMaterial.vue'
import MaterialInExpeditonFlux from '../graph/MaterialInExpeditonFlux.vue'
import ExpeditionLeadTime from '../graph/ExpeditionLeadTime.vue'

export default {
  name: 'GraphReference',
  components: { 
    WorkstationStateGraph,
    GraphControversyMaterial,
    MaterialInExpeditonFlux,
    ExpeditionLeadTime,
  },
  data: function() {
    return {
      graphOptions: [
        {keyg: 'material_in_exp_flux', name: 'Matériel dans le flux d\'expédition'},
        {keyg: 'material_controversy', name: 'Matériel en litige'},
        {keyg: 'exp_leadtime', name: 'Lead Time d\'expédition'},
        {keyg: 'workstation_state', name: 'Etat des gares'},
      ],
      selectedGraph: '',
      keyGraph: '',
      isLoading : false,
    }
  },
  mounted () {
  },
  methods: {
    displayGraph (graphKey, graphName) {
        this.selectedGraph = graphName
        this.keyGraph = graphKey
    },
    formatReference (reference) {
      return reference.substr(0, 3) + ' ' + reference.substr(3, 3) + ' ' + reference.substr(6, 3)
    },
  }
}
</script>

<style>
.graph-options-wrapper {
  text-align: left;
  float: left;
}

.btn-options-graph {
  background-color: #eeeeee;
  border-color: #eeeeee;
  color: #242424;
  border-radius: 0,2rem;
  height: 85px;
}

.btn-options-graph.active {
  background-color: #2a6fAe;
  color: "#eeeeee";
}

.graph-wrapper {
  margin-top: 2%;
  text-align: left;
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/graph/GraphReference.vue